import { ConfigParser, ConfigParserError } from 'core/config/config-parser';
import { GlobalConstants } from 'core/constants';
import { ProductDesignerComponentConfig
       } from './product-designer-component-config';

export class ProductDesignerComponentConfigParser extends ConfigParser
{

  /**
   * @throws ConfigParserError
   */
  public getConfig(): ProductDesignerComponentConfig
  {
    this.validateConfig();
    let priceFormat = this.genericConfigObject.price_format;
    priceFormat.style = 'currency';
    const mode = this.genericConfigObject.mode ?
        this.genericConfigObject.mode : GlobalConstants.MODE_DEFAULT;

    let config = <ProductDesignerComponentConfig> {
        locale: this.genericConfigObject.locale,
        priceFormat: priceFormat,
        galleriesImageStoreURL:
            this.genericConfigObject.galleries_image_store_url,
        traudlURL: this.genericConfigObject.traudl_url,
        galleryImageDisposition:
            this.genericConfigObject.gallery_image_disposition,
        fontStoreURL: this.genericConfigObject.font_store_url,
        loggingURL: this.genericConfigObject.logging_url,
        heartbeatURL: this.genericConfigObject.heartbeat_url ?
            this.genericConfigObject.heartbeat_url : undefined,
        designResultsURL: this.genericConfigObject.design_results_url,
        cartURL: this.genericConfigObject.cart_url ?
            this.genericConfigObject.cart_url : undefined,
        productStoreURL: this.genericConfigObject.product_store_url,
        prnglURL: this.genericConfigObject.prngl_url ?
            this.genericConfigObject.prngl_url : undefined,
        catalogStoreId: this.genericConfigObject.catalog_store_id,
        catalogRevision: this.genericConfigObject.catalog_revision,
        mode: mode,
    };

    return config;
  }

  /**
   * @throws ConfigParserError
   */
  private validateConfig(): void
  {
    if (this.genericConfigObject === undefined) {
      throw new ConfigParserError('settings is undefined');
    }

    if (this.genericConfigObject.locale === undefined) {
      throw new ConfigParserError('locale is undefined');
    }
    if (this.genericConfigObject.price_format === undefined) {
      throw new ConfigParserError('price_format is undefined');
    }
    if (this.genericConfigObject.galleries_image_store_url === undefined) {
      throw new ConfigParserError('galleries_image_store_url is undefined');
    }
    if (this.genericConfigObject.font_store_url === undefined) {
      throw new ConfigParserError('font_store_url is undefined');
    }
    if (this.genericConfigObject.logging_url === undefined) {
      throw new ConfigParserError('logging_url is undefined');
    }
    if (this.genericConfigObject.catalog_store_id === undefined) {
      throw new ConfigParserError('catalog_store_id is undefined');
    }
    if (this.genericConfigObject.design_results_url === undefined) {
      throw new ConfigParserError('design_results_url is undefined');
    }
  }
}
